import { Typography } from '@design-system/components/typography/typography';
import * as styles from './OnboardingCard.css';
import clsx from 'clsx';

type OnboardingCardType = {
  title: string;
  subtitle?: string;
  description: string;
  image: string;
  link: string;
  isFullWidth?: boolean;
  onClick?: () => void;
};

export const OnboardingCard = ({
  title,
  subtitle,
  description,
  image,
  link,
  isFullWidth,
  onClick,
}: OnboardingCardType) => {
  return (
    <a
      href={link}
      className={clsx(styles.card, isFullWidth && styles.fullWidth)}
      target="_blank"
      rel="noreferrer noopener"
      onClick={() => {
        onClick && onClick();
      }}
    >
      <Typography variant="title" size="large">
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body" fontWeight="bold" color="N-100">
          {subtitle}
        </Typography>
      )}
      <Typography variant="body" fontWeight="normal">
        {description}
      </Typography>
      <div className={styles.imageWrapper}>
        <img
          src={image}
          className={styles.image}
          alt="Creator community collage"
        />
      </div>
    </a>
  );
};
